/* tslint:disable */

/**
 */
export class GenericResponse {
    status?: boolean;
    message?: string;
}
